import Homework from './component';

import _routes from './routes';

export const routes = _routes;

export default Homework;



// WEBPACK FOOTER //
// ./containers/Group/Homework/index.js